import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'grabbill-client-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
